import { CanConnectOrBindSuiteErrors } from '../../typing';
import { isCountryCodeSubdomain, parseDomain } from '../../utils';
import { ConnectionType } from '@wix/ambassador-premium-domains-v1-connected-domain/types';
import { ManagementTypeEnumManagementType } from '@wix/ambassador-domains-userdomain-v1-user-domain/types';
export const canConnectOrBindDomainSuite = async _ref => {
  let {
    httpClient,
    request: {
      domain,
      msid
    }
  } = _ref;
  if (!domain) {
    return {
      canConnectOrBind: false
    };
  }
  const parsedDomain = domain.asciiDomain ? domain : parseDomain(domain);
  const rootDomain = parsedDomain.asciiDomain;
  const fullAsciiDomain = parsedDomain.fullAsciiDomain;
  const isSubdomain = !!parsedDomain.subdomain;
  if (isSubdomain) {
    return canConnectOrBindSubdomain({
      httpClient,
      subdomain: fullAsciiDomain,
      rootDomain,
      msid
    });
  } else {
    return canConnectOrBindRootDomain({
      httpClient,
      rootDomain,
      msid
    });
  }
};
async function canConnectOrBindRootDomain(_ref2) {
  let {
    httpClient,
    rootDomain,
    msid
  } = _ref2;
  const {
    checkDomainIsTaken,
    userDomain
  } = (await import('../ApiClients/DomainsApiClient')).DomainsApiClient.queries({
    httpClient
  });
  const {
    error: userDomainError,
    site
  } = await userDomain({
    domain: rootDomain,
    withSiteData: true
  }, {
    cacheTime: 0
  });
  const isRootDomainInAccount = !userDomainError;
  if (userDomainError === 'belongsToAnotherAccount') {
    return {
      error: CanConnectOrBindSuiteErrors.DOMAIN_TAKEN_IN_WIX,
      canConnectOrBind: false
    };
  }
  if (userDomainError === 'unauthorized') {
    return {
      canConnectOrBind: false,
      error: CanConnectOrBindSuiteErrors.UNAUTHORIZED
    };
  }
  if (isRootDomainInAccount) {
    if (site != null && site.siteId) {
      const metaSiteId = msid || site.siteId;
      return {
        error: metaSiteId === site.siteId ? CanConnectOrBindSuiteErrors.ALREADY_ASSIGNED_TO_THIS_SITE : CanConnectOrBindSuiteErrors.ALREADY_ASSIGNED,
        canConnectOrBind: true,
        assignedSite: site
      };
    }
    return {
      error: CanConnectOrBindSuiteErrors.FLOATING_DOMAIN,
      canConnectOrBind: true
    };
  }
  const {
    isAvailable,
    error
  } = await checkDomainIsTaken({
    domain: rootDomain
  });
  if (!isAvailable && !error) {
    return {
      canConnectOrBind: true
    };
  }
  return {
    canConnectOrBind: false
  };
}
async function canConnectOrBindSubdomain(_ref3) {
  let {
    httpClient,
    subdomain,
    rootDomain
  } = _ref3;
  const {
    getConnectedDomain,
    userDomain
  } = (await import('../ApiClients/DomainsApiClient')).DomainsApiClient.queries({
    httpClient
  });
  const [subdomainUserDomain, rootDomainUserDomain] = await Promise.all([userDomain({
    domain: subdomain
  }, {
    cacheTime: 0
  }), userDomain({
    domain: rootDomain
  }, {
    cacheTime: 0
  })]);
  const subdomainUserDomainError = subdomainUserDomain == null ? void 0 : subdomainUserDomain.error;
  const isSubdomainInAccount = !(subdomainUserDomain != null && subdomainUserDomain.error);
  const ccPremiumError = isCountryCodeSubdomain(subdomain) ? CanConnectOrBindSuiteErrors.LANGUAGE_CODE_SUBDOMAIN : undefined;
  if (isSubdomainInAccount) {
    return {
      canConnectOrBind: true,
      error: ccPremiumError || CanConnectOrBindSuiteErrors.SUBDOMAIN_ALREADY_ASSIGNED
    };
  }
  if (subdomainUserDomainError === 'belongsToAnotherAccount' || (rootDomainUserDomain == null ? void 0 : rootDomainUserDomain.error) === 'belongsToAnotherAccount') {
    return {
      error: CanConnectOrBindSuiteErrors.DOMAIN_TAKEN_IN_WIX,
      canConnectOrBind: false
    };
  }
  if (subdomainUserDomainError === 'unauthorized') {
    return {
      canConnectOrBind: false,
      error: CanConnectOrBindSuiteErrors.UNAUTHORIZED
    };
  }
  try {
    const {
      connectedDomain
    } = await getConnectedDomain({
      connectedDomainId: rootDomain
    });
    if ((connectedDomain == null ? void 0 : connectedDomain.connectionType) === ConnectionType.POINTING) {
      return {
        error: CanConnectOrBindSuiteErrors.ROOT_DOMAIN_IS_CONNECTED_BY_POINTING,
        canConnectOrBind: false
      };
    }
    const subdomainRootIsConnectedByDns = (connectedDomain == null ? void 0 : connectedDomain.connectionType) === ConnectionType.NAMESERVERS ? CanConnectOrBindSuiteErrors.SUBDOMAIN_ROOT_IS_CONNECTED_BY_DNS : undefined;
    return {
      canConnectOrBind: true,
      error: ccPremiumError || subdomainRootIsConnectedByDns
    };
  } catch (e) {
    var _e$response, _rootDomainUserDomain;
    const statusCode = (e == null || (_e$response = e.response) == null ? void 0 : _e$response.status) ?? (e == null ? void 0 : e.status);
    const subdomainRootIsRegistered = ((_rootDomainUserDomain = rootDomainUserDomain.domain) == null ? void 0 : _rootDomainUserDomain.managementType) === ManagementTypeEnumManagementType.REGISTRATION ? CanConnectOrBindSuiteErrors.SUBDOMAIN_ROOT_IS_REGISTERED : undefined;
    switch (statusCode) {
      case 404:
        {
          return {
            canConnectOrBind: true,
            error: ccPremiumError || subdomainRootIsRegistered
          };
        }
      default:
        return {
          canConnectOrBind: false
        };
    }
  }
}
//# sourceMappingURL=canConnectOrBindDomainSuite.js.map